import { SAVE_PROJECT_ACCESS } from "@actions/project/access"

import { addGlobalMessage } from "@api/utils/"
import { post } from "@api/fetch"

export const updateUsersAccess = (projectId, userIds, cb = null) => dispatch =>
  dispatch(
    post(SAVE_PROJECT_ACCESS, `projects/${projectId}/access`, { userIds }, res => {
      if (typeof cb === "function") {
        cb()
      }
      dispatch(addGlobalMessage("Saved!", "success"))
    })
  )